import { studioApiSdk } from '@/lib/fetcher'
import { RunCodeRequest, RunCodeResponse } from '@/features/code-runner'

export const runCode = async (request: RunCodeRequest): Promise<RunCodeResponse> => {
 return studioApiSdk.runCode(request)
}
